import {forwardRef} from "react";
import {Box, BoxProps, Tooltip} from "@mantine/core";
import cx from "clsx";
import statusClasses from "@/protocols/studies/steps/StepStatusIcon.module.css";
import {IProtocolStepStatus} from "@/protocols/types/protocol.ts";
import {IconSquareLetterCFilled, IconSquareLetterIFilled, IconSquareLetterSFilled} from "@tabler/icons-react";

interface StepStatusProps extends BoxProps {
    status: IProtocolStepStatus;
    selected: boolean;
    onChange: (status: IProtocolStepStatus) => void;
}

export const StepStatusIcon = forwardRef<HTMLDivElement, StepStatusProps>(({
                                                                               className,
                                                                               status,
                                                                               selected,
                                                                               onChange,
                                                                               ...others
                                                                           }, ref) => {
    const statusClass = () => {
        switch (status) {
            case IProtocolStepStatus.INCOMPLETE:
                return statusClasses.statusIncomplete;
            case IProtocolStepStatus.COMPLETED:
                return statusClasses.statusCompleted;
            case IProtocolStepStatus.SKIPPED:
                return statusClasses.statusSkipped;
        }
    }
    const statusIcon = () => {

        switch (status) {
            case IProtocolStepStatus.INCOMPLETE:
                return <Tooltip bd={"var(--bios-border)"} position={"top"} withArrow label={"Incomplete."}>
                    <IconSquareLetterIFilled size="1.5rem"/>
                </Tooltip>
            case IProtocolStepStatus.COMPLETED:
                return <Tooltip bd={"var(--bios-border)"} position={"top"} withArrow label={"Completed."}>
                    <IconSquareLetterCFilled size="1.5rem"/>
                </Tooltip>
            case IProtocolStepStatus.SKIPPED:
                return <Tooltip bd={"var(--bios-border)"} position={"top"} withArrow label={"Skipped."}>
                    <IconSquareLetterSFilled size="1.5rem"/>
                </Tooltip>
        }
    }
    return (
        <Box
            ref={ref}
            style={{display: "grid", grid: "auto / auto"}}
            className={cx(statusClass(), selected && statusClasses.selected, className)}
            onClick={(e) => {
                e.stopPropagation();
                onChange(status);
            }}
            {...others}
        >
            {statusIcon()}
        </Box>
    );
});